module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control button has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n    style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\r\n            z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\r\n            -moz-border-radius: 0px;cle\r\n            border-radius: 0px;\r\n            border: 1px dotted #ffffff;\r\n            z-index: ")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"  style=\"width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\" style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable\"> \r\n        <div style=\"margin: 0; \r\n                  display: flex;\r\n                  align-items: center;\r\n                  justify-content: flex-end;\r\n                  height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                  -webkit-border-radius: 0px;\r\n                  -moz-border-radius: 0px;\r\n                  border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                  border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                  font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append("; font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                  font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                  color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";                  \r\n                  background-color: ")
    ; __append(escapeFn(styleBGColorText))
    ; __append(" \">           \r\n\r\n                <div style=\"display: ")
    ; __append(escapeFn( type === 'dropdown' ? 'flex' : 'none' ))
    ; __append(";\r\n                            align-items: center;\r\n                            justify-content: flex-center;\r\n                            width: 20px;\r\n                            min-height: 15px;\r\n                            height: ")
    ; __append(escapeFn( u.extractNum(height)- 10 ))
    ; __append("px;\">           \r\n                    <img draggable=\"false\" src=\"")
    ; __append( require('editor/icons/down-arrow.png') )
    ; __append("\"  width=\"15px\"/>    \r\n                </div>\r\n        </div>  \r\n    </div>\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; top: 0;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px; bottom: -2px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}